import Vue from 'vue'

import ApiService from '@/common/api.service'
import LoginService from '@/common/login.service'

import { mapGetters } from "vuex";

import {
	ADD_USER
} from '@/store/actions.type'

import {

} from '@/store/mutations.type'

const state = {

}

export const actions = {
	[ADD_USER] (context, payload) {
		const session_id = payload.session ? payload.session.id : null;
		const sCode = payload.sCode ? payload.sCode : null;
		return new Promise((resolve, reject) => {
			LoginService.attemptLogin(session_id, sCode)
			.then(e => {
				resolve(e);
			})
			.catch(e => {
				reject(e);
			});
		});
	}
}

const mutations = {

}

const getters = {

}

export default {
	state,
	getters,
	actions,
	mutations
}